<template>
  <div>
    <div class="columns">
      <div class="column">
        <l-field
          :label="
            $t('compTransitionMapsFiltersitemsLaboratory.field-disciplines')
          "
          :tooltip="
            $t('compTransitionMapsFiltersitemsLaboratory.tooltip-disciplines')
          "
          label-position="on-border"
        >
          <treeselect
            :multiple="true"
            :options="disciplinesTree"
            value-consists-of="LEAF_PRIORITY"
            :placeholder="
              $t('compTransitionMapsFiltersitemsLaboratory.select-disciplines')
            "
            v-model="filters.disciplines"
            @input="inputChanged"
          />
        </l-field>
      </div>
      <div class="column is-one-third">
        <div class="block">
          <l-field
            label=""
            :tooltip="
              $t(
                'compTransitionMapsFiltersitemsLaboratory.tooltip-disciplines-op'
              )
            "
            label-position="on-border"
          >
            <b-radio-button
              @input="inputChanged"
              v-model="filters.disciplinesOp"
              size="is-small"
              native-value="AND"
            >
              {{ $t('compTransitionMapsFiltersitemsLaboratory.filter:and') }}
            </b-radio-button>
            <b-radio-button
              @input="inputChanged"
              v-model="filters.disciplinesOp"
              size="is-small"
              native-value="OR"
            >
              {{ $t('compTransitionMapsFiltersitemsLaboratory.filter:or') }}
            </b-radio-button>
          </l-field>
        </div>
      </div>
    </div>

    <!-- Administrations -->
    <div class="columns">
      <div class="column">
        <l-field
          :label="$t('compTransitionMapsFiltersitemsLaboratory.field-tutelles')"
          :tooltip="
            $t('compTransitionMapsFiltersitemsLaboratory.tooltip-tutelles')
          "
          label-position="on-border"
        >
          <administration-input @input="admChanged" />
        </l-field>
      </div>
      <div class="column is-one-third">
        <div class="block">
          <l-field
            label=""
            :tooltip="
              $t('compTransitionMapsFiltersitemsLaboratory.tooltip-tutelles-op')
            "
            label-position="on-border"
          >
            <b-radio-button
              @input="inputChanged"
              v-model="filters.administrationsOp"
              size="is-small"
              native-value="AND"
            >
              {{ $t('compTransitionMapsFiltersitemsLaboratory.filter:and') }}
            </b-radio-button>
            <b-radio-button
              @input="inputChanged"
              v-model="filters.administrationsOp"
              size="is-small"
              native-value="OR"
            >
              {{ $t('compTransitionMapsFiltersitemsLaboratory.filter:or') }}
            </b-radio-button>
          </l-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import coreService from '@/services/coreService'
import { buildDisciplinesTree } from '@/models/transition/utils.js'

export default {
  name: 'FiltersLaboratory',
  components: {
    'administration-input': () =>
      import('@/components/core/AdministrationInput.vue'),
    'l-field': () => import('@/components/LField.vue'),
    treeselect: () => import('@riophae/vue-treeselect')
  },
  data: function () {
    return {
      filters: {
        disciplines: [],
        disciplinesOp: 'AND',
        administrations: [],
        administrationsOp: 'AND'
      },
      disciplinesTree: {}
    }
  },
  methods: {
    inputChanged () {
      this.$emit('filterChanged', this.filters)
    },
    admChanged (administrations) {
      this.filters.administrations = administrations
      this.$emit('filterChanged', this.filters)
    }
  },
  mounted () {
    coreService.getDisciplines().then((disciplines) => {
      this.disciplinesTree = buildDisciplinesTree(disciplines)
    })
  }
}
</script>
